/**
 * Sullivan Ridge & Co. — Scroll Reveal & Ambient Animations
 * Lightweight IntersectionObserver — no dependencies
 */
(function () {
  'use strict';

  /* ------------------------------------------------------------------
     1. SCROLL REVEAL
     Apply .sr-hidden to target elements, then toggle .sr-visible
     ------------------------------------------------------------------ */
  function initScrollReveal() {
    var targets = [
      '.card-wrapper',
      '.product-card-wrapper',
      '.featured-collection',
      '.collection-list__item',
      '[class*="rich-text"]',
      '[class*="image-with-text"]',
      '.footer [class*="grid__item"]'
    ].join(', ');

    var els = document.querySelectorAll(targets);
    if (!els.length) return;

    els.forEach(function (el) { el.classList.add('sr-hidden'); });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('sr-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    els.forEach(function (el) { observer.observe(el); });
  }

  /* ------------------------------------------------------------------
     2. AMBIENT FLOATING PARTICLES — hero section only, very subtle
     ------------------------------------------------------------------ */
  function initParticles() {
    var hero = document.querySelector(
      '[class*="hero"] .media-container, [class*="hero"] .media, .hero'
    );
    if (!hero) return;
    if (window.innerWidth < 990) return;

    var canvas = document.createElement('canvas');
    canvas.style.cssText = 'position:absolute;inset:0;pointer-events:none;z-index:2;opacity:0.18';
    hero.style.position = hero.style.position || 'relative';
    hero.appendChild(canvas);

    var ctx = canvas.getContext('2d');
    var particles = [];
    var count = 28;

    function resize() {
      canvas.width  = hero.offsetWidth;
      canvas.height = hero.offsetHeight;
    }
    resize();
    window.addEventListener('resize', resize, { passive: true });

    for (var i = 0; i < count; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        r: Math.random() * 1.8 + 0.4,
        vx: (Math.random() - 0.5) * 0.18,
        vy: -Math.random() * 0.28 - 0.06,
        alpha: Math.random() * 0.6 + 0.2
      });
    }

    function draw() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach(function (p) {
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(200,169,110,' + p.alpha + ')';
        ctx.fill();
        p.x += p.vx;
        p.y += p.vy;
        if (p.y < -4) { p.y = canvas.height + 4; p.x = Math.random() * canvas.width; }
        if (p.x < 0) p.x = canvas.width;
        if (p.x > canvas.width) p.x = 0;
      });
      requestAnimationFrame(draw);
    }
    draw();
  }

  /* ------------------------------------------------------------------
     3. STICKY HEADER — blur on scroll
     ------------------------------------------------------------------ */
  function initStickyHeader() {
    var header = document.querySelector('#header-component, header, .header');
    if (!header) return;

    var scrolled = false;
    window.addEventListener('scroll', function () {
      var past = window.scrollY > 60;
      if (past !== scrolled) {
        scrolled = past;
        header.style.transition = 'backdrop-filter 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease';
        if (scrolled) {
          header.style.backdropFilter = 'blur(12px)';
          header.style.webkitBackdropFilter = 'blur(12px)';
          header.style.boxShadow = '0 1px 20px rgba(28,26,23,0.08)';
        } else {
          header.style.backdropFilter = '';
          header.style.webkitBackdropFilter = '';
          header.style.boxShadow = '';
        }
      }
    }, { passive: true });
  }

  /* ------------------------------------------------------------------
     INIT
     ------------------------------------------------------------------ */
  function init() {
    if (document.documentElement.classList.contains('shopify-design-mode')) return;
    initScrollReveal();
    initParticles();
    initStickyHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
